// Generated by CoffeeScript 2.7.0

// ==============================================================================
// MODULES - COMPONENTS - AHA BUTTONS
// ==============================================================================
import $ from "jquery";

$(function() {
  // Append a disbaled atrribute to some ahaButton submit elements
  $('.C--ahaButtons').each(function() {
    var $this, id;
    $this = $(this);
    id = $this.attr('data-id');
    if (localStorage.getItem(`ahaButton_${id}`)) {
      return $this.find('input[type="submit"]').attr('disabled', 'disabled');
    }
  });
  // When submit button is clicked...
  return $('.C--ahaButtons > input[type="submit"]').on('click', function(e) {
    var $this, disableButton, id;
    // Prevent Default Call
    e.preventDefault();
    // Set variables
    $this = $(this);
    id = $this.parent().attr('data-id');
    // Define a method to success after posting a specific API
    disableButton = function($span) {
      localStorage.setItem(`ahaButton_${id}`, 'true');
      $span.html(-(-$span.html()) + 1);
      return $(`.C--ahaButtons[data-id=\"${id}\"] > input[type=\"submit\"]`).attr('disabled', 'disabled');
    };
    // Do not emit click event if set a flag or set a disable attribute
    if ($this.attr('disabled') || localStorage.getItem(`ahaButton_${id}`)) {
      return;
    }
    return $.ajax({
      type: 'POST',
      url: `${document.URL}/understanding`,
      data: {id},
      success: function() {
        return disableButton($('.C--ahaButtons > span'));
      }
    });
  });
});
